import styled, { css } from 'styled-components';

import { mediaDesktop } from 'utils/styles/responsive';
import { colors } from 'utils/styles/theme';

export const SectionsHeroWrapper = styled.div<{ url: string }>`
  grid-column: 1/-1;
  height: 100vh;
  width: 100%;
  aspect-ratio: 16 / 9;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-color: ${colors.black};
  margin-bottom: 120px;

  ${({ url }) => css`
    background-image: url('${url}');
  `}

  ${mediaDesktop(css`
    margin-bottom: 223px;

    height: auto;
    background-size: cover;
  `)}
`;
